import Marionette from 'backbone.marionette';
import journalVoteEmptyviewTmpl from '../templates/journal_vote_emptyview.tpl';
export default Marionette.ItemView.extend({
  template: journalVoteEmptyviewTmpl,
  tagName: 'tr'
});